<script lang="ts">
	import toISOString from "../libs/date/format";
	import type { TargetAlternate } from "../libs/app/target-alternate";
	import { telno2intl } from "../libs/telno2intl/telno2intl";

	export let closeModal: any;
	export let saveCallback: Function;

	let targetAlternateName: string;
	let targetAlternateTelno: string;
	let targetScheduleTimeAlternate: boolean;
	let scheduledDate = toISOString(new Date(), false);
	let scheduledTime: string;

	$: disabledSave = checkDisabledSave(
		targetAlternateName,
		targetAlternateTelno,
		targetScheduleTimeAlternate,
		scheduledTime
	);

	async function saveCallAlternate() {
		let _scheduledTime = null;
		if (scheduledTime) {
			if (!scheduledDate) {
				scheduledDate = toISOString(new Date(), false);
			}
			_scheduledTime = scheduledDate + " " + scheduledTime;
		}

		const targetAlternate: TargetAlternate = {
			name: targetAlternateName,
			telno: targetAlternateTelno,
			time_scheduled: _scheduledTime,
		};

		saveCallback(targetAlternate);
		closeModal();
	}

	function checkDisabledSave(
		targetAlternateName,
		targetAlternateTelno,
		targetScheduleTimeAlternate,
		scheduledTime
	): boolean {
		if (!targetAlternateName || !targetAlternateTelno) {
			return true;
		}

		if (targetScheduleTimeAlternate === true && !scheduledTime) {
			return true;
		}

		const r = telno2intl(targetAlternateTelno);
		if (r.ton === 1) {
			return false;
		}

		return true;
	}
</script>

<div class="modal-backdrop-custom" />

<div class="modal">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">Volať náhradníka</div>

			<div class="modal-body">
				<form class="row g-3">
					<div class="col-md-12">
						<label for="name" class="form-label">Meno</label>
						<input
							type="text"
							class="form-control"
							id="name"
							bind:value={targetAlternateName} />
					</div>

					<div class="col-md-12">
						<label for="telno" class="form-label"
							>Telefónne číslo</label>
						<input
							type="text"
							class="form-control"
							id="telno"
							bind:value={targetAlternateTelno} />
					</div>

					<div class="col-md-12">
						<input
							type="checkbox"
							class="form-check-input"
							id="schedule"
							bind:checked={targetScheduleTimeAlternate} />
						<label class="form-check-label" for="schedule"
							>Volať v určený čas</label>
					</div>

					{#if targetScheduleTimeAlternate === true}
						<div class="col-md-6">
							<label for="date" class="form-label">Dátum</label>
							<input
								type="date"
								class="form-control"
								id="date"
								bind:value={scheduledDate} />
						</div>

						<div class="col-md-6">
							<label for="time" class="form-label">Čas</label>
							<input
								type="time"
								class="form-control"
								id="time"
								bind:value={scheduledTime} />
						</div>
					{/if}
				</form>
			</div>

			<div class="modal-footer">
				<button
					class="btn btn-primary"
					on:click={saveCallAlternate}
					disabled={disabledSave}>Naplánovať</button>
				<button class="btn btn-secondary" on:click={closeModal}
					>Zrušiť</button>
			</div>
		</div>
	</div>
</div>

<style>
	.modal-backdrop-custom:before {
		content: "";
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: #000;
		opacity: 0.7;
	}

	.modal {
		display: block;
	}
</style>
